import React from 'react';
import { defaultStyles, FileIcon } from 'react-file-icon';
import classnames from 'classnames';
import * as XLSX from 'xlsx';

import FileUtil from '@utils/FileUtil';

import { IDisplayEditAttachment } from '../Attachment/AttachmentsEditModal';

import DownloadButton from './DownloadAttachment';

import './style.scss';

interface IXlsxViewerProps {
  attachment: IDisplayEditAttachment;
}

interface IXlsxViewerState {
  showFallbackComponent: boolean;
  data: any[];
}

class XlsxViewer extends React.Component<IXlsxViewerProps, IXlsxViewerState> {
  constructor(props: IXlsxViewerProps) {
    super(props);

    this.state = {
      showFallbackComponent: false,
      data: [],
    };
  }

  componentDidMount() {
    const { fileURL } = this.props.attachment;
    this.parseXLSXData(fileURL);
  }

  parseXLSXData = (fireURL: string) => {
    fetch(fireURL)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        return response.blob();
      })
      .then((blob) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: 'binary' });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const parsedData = XLSX.utils.sheet_to_json(sheet);
          this.setState({ data: parsedData });
        };
        reader.onerror = (error) => {
          console.error('Error reading the file:', error);
          this.onError();
        };
        reader.readAsBinaryString(blob);
      })
      .catch((error) => {
        console.error('Error fetching the file:', error);
        this.onError();
      });
  };

  onError = () => {
    this.setState({
      showFallbackComponent: true,
    });
  };

  render() {
    const { attachment } = this.props;
    const { fileURL } = attachment;
    const fileExtension: string = FileUtil.getFileExtension(fileURL);
    const { data } = this.state;

    if (this.state.showFallbackComponent) {
      const fallbackMsg =
        'Something went wrong while loading attachment. Please download the attachment from the link below.';

      return (
        <>
          <div className={classnames('document-view-fallback attachments-tile__saved-thumb')}>
            <FileIcon extension={fileExtension} {...defaultStyles[fileExtension]} />
          </div>
          <DownloadButton attachment={attachment} errMsg={fallbackMsg} />
        </>
      );
    }

    return (
      <div className={classnames('table-responsive')}>
        {data.length > 0 && (
          <table className="table">
            <thead>
              <tr>
                {Object.keys(data[0] || {}).map((key) => (
                  <th key={key}>{key}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {Object.values(row).map((value, columnIndex) => (
                    <td key={`${rowIndex}-${columnIndex}`}>{value}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    );
  }
}

export default XlsxViewer;
